<template>
  <div>
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#68D389" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap align-center py-4>
          <v-flex xs12 sm6 text-left>
            <span style="font-family: poppinsbold; font-size: 20px">Refunds Report</span>
          </v-flex>
          <v-flex xs12 sm6 text-right>
            <v-btn small depressed color="#68D389" dark :loading="excelLoading" @click="downloadExcel()">
              <v-icon left small>mdi-microsoft-excel</v-icon>Download Excel
            </v-btn>
          </v-flex>
        </v-layout>

        <!-- Filters -->
        <v-card outlined class="pa-3 mb-4" style="border-color:#C8E6C9">
          <v-layout wrap align-center>
            <v-flex xs12 sm3 md2 pa-2>
              <v-select
                v-model="filterType"
                :items="filterTypes"
                item-text="text"
                item-value="value"
                label="Filter by"
                color="#68D389"
                outlined
                dense
                hide-details
                @change="onFilterTypeChange"
              ></v-select>
            </v-flex>

            <!-- Day -->
            <v-flex xs12 sm4 md3 pa-2 v-if="filterType === 'day'">
              <v-menu v-model="menuDay" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="singleDate" label="Select Date" prepend-inner-icon="mdi-calendar"
                    readonly outlined dense hide-details v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="singleDate" color="#68D389" no-title @change="menuDay = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Week -->
            <v-flex xs12 sm4 md3 pa-2 v-if="filterType === 'week'">
              <v-menu v-model="menuWeek" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="weekDate" label="Any date in the week" prepend-inner-icon="mdi-calendar-week"
                    readonly outlined dense hide-details v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="weekDate" color="#68D389" no-title @change="menuWeek = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Month -->
            <v-flex xs12 sm4 md3 pa-2 v-if="filterType === 'month'">
              <v-menu v-model="menuMonth" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="selectedMonth" label="Select Month" prepend-inner-icon="mdi-calendar"
                    readonly outlined dense hide-details v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="selectedMonth" type="month" color="#68D389" no-title @change="menuMonth = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Year -->
            <v-flex xs12 sm4 md3 pa-2 v-if="filterType === 'year'">
              <v-select v-model="selectedYear" :items="years" label="Select Year" color="#68D389"
                outlined dense hide-details></v-select>
            </v-flex>

            <!-- Date Range -->
            <template v-if="filterType === 'range'">
              <v-flex xs12 sm4 md3 pa-2>
                <v-menu v-model="menuFrom" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="rangeFrom" label="From" prepend-inner-icon="mdi-calendar-start"
                      readonly outlined dense hide-details v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="rangeFrom" color="#68D389" no-title @change="menuFrom = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm4 md3 pa-2>
                <v-menu v-model="menuTo" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="rangeTo" label="To" prepend-inner-icon="mdi-calendar-end"
                      readonly outlined dense hide-details v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="rangeTo" color="#68D389" no-title :min="rangeFrom" @change="menuTo = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </template>

            <v-flex xs12 sm3 md2 pa-2>
              <v-btn block depressed color="#68D389" dark :loading="appLoading" @click="applyFilter()">
                <v-icon left small>mdi-magnify</v-icon>Apply
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <!-- Summary -->
        <v-layout wrap pb-4>
          <v-flex xs6 sm3 pa-2>
            <v-card outlined class="pa-3 text-center" style="border-color:#68D389">
              <div style="font-family: poppinsbold; font-size: 24px; color:#2E7D32">{{ count }}</div>
              <div style="font-family: poppinsregular; font-size: 14px">Tickets Refunded</div>
            </v-card>
          </v-flex>
          <v-flex xs6 sm3 pa-2>
            <v-card flat class="pa-3 text-center" color="#F1F8E9">
              <div style="font-family: poppinsbold; font-size: 24px; color:#1B5E20">₹ {{ total }}</div>
              <div style="font-family: poppinsregular; font-size: 14px">Total Refunded</div>
            </v-card>
          </v-flex>
        </v-layout>

        <v-divider class="my-2"></v-divider>

        <v-layout wrap>
          <v-flex xs12 py-4 text-left>
            <span style="font-family: poppinsbold; font-size: 18px">Refunds — {{ currentLabel }}</span>
          </v-flex>
          <v-flex xs12 v-if="refunds && refunds.length">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left"><b>Sl No</b></th>
                    <th class="text-left"><b>Ticket No</b></th>
                    <th class="text-left"><b>Guest</b></th>
                    <th class="text-left"><b>Phone</b></th>
                    <th class="text-left"><b>Type</b></th>
                    <th class="text-left"><b>Status</b></th>
                    <th class="text-right"><b>Refund Amount</b></th>
                    <th class="text-left"><b>Refund Date</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in refunds" :key="i">
                    <td class="text-left">{{ i + 1 }}</td>
                    <td class="text-left"><b>#{{ item.ticketNo }}</b></td>
                    <td class="text-left">{{ item.name || "-" }}</td>
                    <td class="text-left">{{ item.phone || "-" }}</td>
                    <td class="text-left">{{ item.cancelType }}</td>
                    <td class="text-left">{{ item.status }}</td>
                    <td class="text-right">₹ {{ item.refundAmount }}</td>
                    <td class="text-left">{{ formatDate(item.date) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
          <v-flex xs12 text-left pa-5 v-else>
            <span style="font-family:poppinsregular">No refunds found for this period.</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    var now = new Date();
    var todayYMD = this.ymd(now);
    var ym = now.getFullYear() + "-" + ("0" + (now.getMonth() + 1)).slice(-2);
    var years = [];
    for (var y = now.getFullYear(); y >= 2018; y--) years.push(y);
    return {
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      appLoading: false,
      excelLoading: false,

      filterType: "month",
      filterTypes: [
        { text: "Day", value: "day" },
        { text: "Week", value: "week" },
        { text: "Month", value: "month" },
        { text: "Year", value: "year" },
        { text: "Date Range", value: "range" },
      ],
      singleDate: todayYMD,
      weekDate: todayYMD,
      selectedMonth: ym,
      selectedYear: now.getFullYear(),
      rangeFrom: todayYMD,
      rangeTo: todayYMD,
      years: years,

      menuDay: false,
      menuWeek: false,
      menuMonth: false,
      menuFrom: false,
      menuTo: false,

      refunds: [],
      total: 0,
      count: 0,
      currentLabel: "",
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    // helper usable before `this` data is ready (used in data())
    ymd(d) {
      return (
        d.getFullYear() +
        "-" +
        ("0" + (d.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + d.getDate()).slice(-2)
      );
    },
    monthName(m) {
      return [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
      ][m];
    },
    labelFromYMD(s) {
      if (!s) return "";
      var p = s.split("-");
      return p[2] + "-" + p[1] + "-" + p[0];
    },
    // Resolve the currently selected filter into { from, to (YYYY-MM-DD), label }
    computeRange() {
      if (this.filterType === "day") {
        return {
          from: this.singleDate,
          to: this.singleDate,
          label: this.labelFromYMD(this.singleDate),
        };
      }
      if (this.filterType === "week") {
        var d = new Date(this.weekDate);
        var offset = (d.getDay() + 6) % 7; // Monday start
        var mon = new Date(d);
        mon.setDate(d.getDate() - offset);
        var sun = new Date(mon);
        sun.setDate(mon.getDate() + 6);
        return {
          from: this.ymd(mon),
          to: this.ymd(sun),
          label: this.labelFromYMD(this.ymd(mon)) + " to " + this.labelFromYMD(this.ymd(sun)),
        };
      }
      if (this.filterType === "month") {
        var mp = this.selectedMonth.split("-");
        var yy = parseInt(mp[0]);
        var mm = parseInt(mp[1]);
        var first = new Date(yy, mm - 1, 1);
        var last = new Date(yy, mm, 0);
        return {
          from: this.ymd(first),
          to: this.ymd(last),
          label: this.monthName(mm - 1) + " " + yy,
        };
      }
      if (this.filterType === "year") {
        var yr = parseInt(this.selectedYear);
        return {
          from: yr + "-01-01",
          to: yr + "-12-31",
          label: "" + yr,
        };
      }
      // range
      var f = this.rangeFrom, t = this.rangeTo;
      if (new Date(t) < new Date(f)) {
        var tmp = f; f = t; t = tmp;
      }
      return {
        from: f,
        to: t,
        label: this.labelFromYMD(f) + " to " + this.labelFromYMD(t),
      };
    },
    onFilterTypeChange() {
      this.getData();
    },
    applyFilter() {
      this.getData();
    },
    getData() {
      var range = this.computeRange();
      this.appLoading = true;
      axios({
        method: "GET",
        url: "cancel/monthlyrefunds",
        params: { from: range.from, to: range.to, label: range.label },
        headers: { token: localStorage.getItem("token") },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.refunds = response.data.data || [];
            this.total = response.data.total || 0;
            this.count = response.data.count || 0;
            this.currentLabel = response.data.label || range.label;
          } else {
            this.refunds = [];
            this.total = 0;
            this.count = 0;
            this.currentLabel = range.label;
          }
        })
        .catch(() => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    downloadExcel() {
      var range = this.computeRange();
      this.excelLoading = true;
      axios({
        method: "GET",
        url: "cancel/monthlyrefunds/excel",
        params: { from: range.from, to: range.to, label: range.label },
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      })
        .then((response) => {
          this.excelLoading = false;
          if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            var safe = range.label.replace(/[^A-Za-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
            link.setAttribute("download", "Refunds_" + safe + ".xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.msg = "Excel downloaded successfully!";
            this.showSnackBar = true;
          } else {
            this.msg = "No data returned for the Excel report.";
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.excelLoading = false;
          this.ServerError = true;
        });
    },
    formatDate(item) {
      if (!item) return "-";
      var dt = new Date(item);
      var day = ("0" + dt.getDate()).slice(-2);
      var month = ("0" + (dt.getMonth() + 1)).slice(-2);
      return day + "-" + month + "-" + dt.getFullYear();
    },
  },
};
</script>
